import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();
const MIN_QUERY_LENGTH = 3;

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

const SearchSelect = (props) => {
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const isRemoteSearch = props.enableRemoteSearch !== false;
  const isSearchable = props.isSearchable !== false;
  const hasSelectedValue = props?.state?.[props?.optionValue] !== undefined
    && props?.state?.[props?.optionValue] !== null
    && props?.state?.[props?.optionValue] !== "";
  const selectedValue = hasSelectedValue ? props.state : null;

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [props.options]);

  const debounceInputChange = useMemo(
    () => debounce(async (value) => {
      const normalizedValue = value.trim();

      if (!isRemoteSearch || !isSearchable) {
        setLoading(false);
        return;
      }

      if (normalizedValue.length < MIN_QUERY_LENGTH) {
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        await props.onChange(normalizedValue);
      } finally {
        setLoading(false);
      }
    }, 450),
    [isRemoteSearch, isSearchable, props.onChange]
  );

  const noOptionsMessage = () => {
    if (loading) {
      return "Идет поиск...";
    }

    if (isRemoteSearch && isSearchable && inputValue.trim().length < MIN_QUERY_LENGTH) {
      return `Введите минимум ${MIN_QUERY_LENGTH} символа`;
    }

    return "Ничего не найдено";
  };

  return (
    <Select
      name={props.name}
      options={props.options || []}
      value={selectedValue}
      onInputChange={(value, actionMeta) => {
        if (actionMeta.action !== "input-change") {
          return value;
        }

        setInputValue(value);
        debounceInputChange(value);
        return value;
      }}
      onChange={(e) => {
        setLoading(false);
        e ? props.setState(e) : props.setState({ [props.optionValue]: "" });
      }}
      isDisabled={props.isDisabled}
      isLoading={loading}
      getOptionValue={(e) => e[props.optionValue]}
      getOptionLabel={(e) => e[props.optionText]}
      placeholder={props.placeholder}
      defaultValue={props.defaultValue}
      loadingMessage={() => "Поиск..."}
      noOptionsMessage={noOptionsMessage}
      isClearable={props.name !== "parcelPickup" && props.name !== "parcelDelivery"}
      isSearchable={isSearchable}
      components={animatedComponents}
      filterOption={props.disableLocalFilter ? () => true : undefined}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: props.highlightRequired ? "red" : "#ccc",
          minHeight: 42,
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          color: "#6a7f95",
        }),
      }}
    />
  );
};

export default SearchSelect;
